import { graphql } from '@data-access/graphql'
import type { ResultOf } from '@graphql-typed-document-node/core'

export const CartCurrencyDocument = graphql(`
  query cartCurrency {
    cartCurrency
  }
`)

export type CartCurrencyQuery = ResultOf<typeof CartCurrencyDocument>
